// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { TextFieldProps } from "@steiner/MobiusOverrides/TextField";
import Close from "@steiner/XDL/Icons/Close";
import { xBaseTheme } from "@steiner/XDL/types";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        labelProps: {
            mergeCss: true,
            forwardAs: "label",
        },
        clearClickableProps: {
            clickableProps: {
                css: css`
                    &&& {
                        right: 35px;
                    }

                    &:disabled {
                        display: none;
                    }

                    & > ${IconWrapper} {
                        transition: all ease-in-out ${getProp("theme.transition.duration.regular")}ms;
                        color: ${color("primary")};
                    }

                    &:hover > ${IconWrapper} {
                        color: ${color("common.ui9")};
                    }
                `,
            },
            iconProps: {
                size: 16,
                src: Close,
            },
        },
    } as TextFieldProps,
} as xBaseTheme["textField"];
